/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signup_Offer_Start_FreeInputs */

const en_signup_offer_start_free = /** @type {(inputs: Signup_Offer_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start Free`)
};

const zh_hans1_signup_offer_start_free = /** @type {(inputs: Signup_Offer_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费开始`)
};

const pt_br2_signup_offer_start_free = /** @type {(inputs: Signup_Offer_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comece grátis`)
};

const es_signup_offer_start_free = /** @type {(inputs: Signup_Offer_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Empieza gratis`)
};

const fr_signup_offer_start_free = /** @type {(inputs: Signup_Offer_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Démarrer gratuitement`)
};

const de_signup_offer_start_free = /** @type {(inputs: Signup_Offer_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kostenlos starten`)
};

const ru_signup_offer_start_free = /** @type {(inputs: Signup_Offer_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Начать бесплатно`)
};

const it_signup_offer_start_free = /** @type {(inputs: Signup_Offer_Start_FreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inizia gratis`)
};

/**
* | output |
* | --- |
* | "Start Free" |
*
* @param {Signup_Offer_Start_FreeInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const signup_offer_start_free = /** @type {((inputs?: Signup_Offer_Start_FreeInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Offer_Start_FreeInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_signup_offer_start_free(inputs)
	if (locale === "pt-BR") return pt_br2_signup_offer_start_free(inputs)
	if (locale === "es") return es_signup_offer_start_free(inputs)
	if (locale === "fr") return fr_signup_offer_start_free(inputs)
	if (locale === "de") return de_signup_offer_start_free(inputs)
	if (locale === "ru") return ru_signup_offer_start_free(inputs)
	if (locale === "it") return it_signup_offer_start_free(inputs)
	return en_signup_offer_start_free(inputs)
});